// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + (chunkId === "588" ? "schema-dsl-compiler-wasm" : chunkId) + "." + {"282": "8d8a0e1e","588": "e014c43b","797": "a77716a9","947": "106885b9",}[chunkId] + ".js"
}